// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ─── Footer ─────────────────────────────────────────────── */
footer {
  background: var(--bg-surface);
  border-top: 1px solid var(--border);
  padding: 16px 10%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
@media (max-width: 600px) {
  footer {
    flex-direction: column;
    gap: 20px;
    padding: 16px 5%;
    text-align: center;
  }
}

.footer-copy {
  font-size: 0.825rem;
  color: var(--text-muted) !important;
  margin: 0;
}

.footer-links {
  display: flex;
  align-items: center;
  gap: 10px;
}
.footer-links a {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 7px;
  border: 1px solid var(--border);
  color: var(--text-muted) !important;
  transition: border-color 0.2s, color 0.2s, background 0.2s;
}
.footer-links a svg {
  font-size: 1.1rem;
}
.footer-links a:hover {
  border-color: var(--accent);
  color: var(--accent) !important;
  background: var(--accent-soft);
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Footer.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,+DAAA;AAEA;EACE,6BAAA;EACA,mCAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AACF;AACE;EARF;IASI,sBAAA;IACA,SAAA;IACA,gBAAA;IACA,kBAAA;EAEF;AACF;;AACA;EACE,mBAAA;EACA,mCAAA;EACA,SAAA;AAEF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAEF;AAAE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,+BAAA;EACA,mCAAA;EACA,0DAAA;AAEJ;AAAI;EAAM,iBAAA;AAGV;AADI;EACE,2BAAA;EACA,+BAAA;EACA,8BAAA;EACA,UAAA;AAGN","sourcesContent":["/* ─── Footer ─────────────────────────────────────────────── */\n\nfooter {\n  background: var(--bg-surface);\n  border-top: 1px solid var(--border);\n  padding: 16px 10%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  @media (max-width: 600px) {\n    flex-direction: column;\n    gap: 20px;\n    padding: 16px 5%;\n    text-align: center;\n  }\n}\n\n.footer-copy {\n  font-size: 0.825rem;\n  color: var(--text-muted) !important;\n  margin: 0;\n}\n\n.footer-links {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n\n  a {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 36px;\n    height: 36px;\n    border-radius: 7px;\n    border: 1px solid var(--border);\n    color: var(--text-muted) !important;\n    transition: border-color 0.2s, color 0.2s, background 0.2s;\n\n    svg { font-size: 1.1rem; }\n\n    &:hover {\n      border-color: var(--accent);\n      color: var(--accent) !important;\n      background: var(--accent-soft);\n      opacity: 1;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
